import {Component, OnInit} from '@angular/core';
import {Banner} from '../../constants/constant-text';
import {errorBanner} from '../../utils/error-message';
import {Question} from '../../models/question.model';
import {Router} from '@angular/router';
import {TrainingService} from '../../services/training.service';
import {DataService} from '../../services/data.service';
import {BehaviorSubject} from 'rxjs';

@Component({
  selector: 'app-quiz',
  templateUrl: './quiz.component.html',
  styleUrls: ['./quiz.component.scss']
})
export class QuizComponent implements OnInit {

  private questions$: Question[];
  public banner = Banner;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();
  public error = false;
  public errorBanner = Banner.ERROR_SUBMIT;

  constructor(private dataService: DataService,
              private trainingService: TrainingService,
              private router: Router) {
  }

  ngOnInit(): void {
    this.questions = this.dataService.questions;
    let i = 1;
    this.questions.forEach(question => {
      question.index = i;
      i++;
    });
  }

  submit(answers: Question[]): void {
    this.loadingSubject.next(true);
    this.trainingService.submit(answers, {
      domain: this.dataService.domain,
      documentId: this.dataService.documentId,
      qaId: this.dataService.qaId,
      userId: this.dataService.userId,
      libraryId: this.dataService.libraryId,
      documentClassIdLog: this.dataService.documentClassIdLog,
      quizSheetName: this.dataService.quizSheetName
    }).subscribe({
      next: async resp => {
        this.dataService.result = resp;
        this.loadingSubject.next(false);
        await this.router.navigate(['result']);
      },
      error: error => {
        console.error(error);
        this.loadingSubject.next(false);
        this.error = true;
        this.errorBanner = errorBanner(Banner.ERROR_SUBMIT, error);
      }
    });
  }

  get questions(): Question[] {
    return this.questions$;
  }

  set questions(questions) {
    this.questions$ = questions;
  }

}
